import React from "react";
import styled from "theme/libs/styled";

const Circle = styled("div")`
    border-radius: 50%;
`;

const ColorCircle = (props) => {
    return <Circle {...props} />;
};
export default ColorCircle;
